package redmcrosco.alex.farmatch.models

import kotlinx.serialization.Serializable

@Serializable
enum class UserRole {
    FARMACISTA,
    FARMACIA,
    ADMIN
}
